// components/organism/Login/LoginForm.tsx
import React from 'react';
import { Row, TextLink, Form } from 'shared-portal-component';
import { z } from 'zod';

import type { FieldErrors } from '@/types/shared/form.types';

const schema = z.object({
  username: z.string().nonempty('Username is required'),
  password: z.string().nonempty('Password is required'),
});

interface LoginFormProps {
  onSubmit: (values: { username: string; password: string }) => void;
  loading?: boolean;
  error?: string;
  fieldErrors: FieldErrors;
}

/**
 * Pure presentational login form.
 * No Redux, no side effects, fully controlled.
 */
const LoginForm: React.FC<LoginFormProps> = ({
  onSubmit,
  loading = false,
  error,
  fieldErrors
}) => {
  const fields = [
    {
      name: 'username',
      label: 'Username',
      placeholder: 'Please enter your username',
      required: true,
      variant: 'outline' as const,
      type: 'text',
      error: fieldErrors.username, // ✅ Display field-level errors
    },
    {
      name: 'password',
      label: 'Password',
      placeholder: 'Please enter your password',
      required: true,
      type: 'password',
      variant: 'outline' as const,
      error: fieldErrors.password, // ✅ Display field-level errors
    },
    {
      name: 'forgot-password',
      label: 'Forgot Password',
      type: 'display',
      display: (
        <Row spacing='none' justify='end' className='w-full'>
          <TextLink
            text="Forgot password?"
            href="/forgot-password"
            variant='primary'
          />
        </Row>
      ),
    }
  ];

  return (

        <Form
          schema={schema}
          fields={fields}
          onSubmit={onSubmit}
          apiError={error}
          // disabled={loading}
        />

  );
};

export default LoginForm;
